import { FooterProps } from "@/types";
import { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../zustand/Zustand";
import ChangelogDialog from "./ChangelogDialog";

const Footer: FC<FooterProps> = ({ showCta = false }) => {
  const { t } = useTranslation(['home', 'common']);
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  const [showChangelog, setShowChangelog] = useState(false);

  // On the landing page, render a single compact band: links + copyright on
  // one row instead of CTA / 3-column grid / copyright as three separate stripes.
  // Every other route shows just the slim copyright bar.
  return (
    <>
      <footer className="bg-fp-header border-t border-fp-border shrink-0">
        {showCta ? (
          <div className="mx-auto max-w-7xl px-6 py-5 lg:px-8">
            <div className="flex flex-col items-center justify-between gap-3 md:flex-row">
              <p className="text-xs text-gray-500">
                {t('footerCta.copyright')}{" "}
                <a
                  href="https://www.youtube.com/@boophie"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-white"
                >
                  {t('footerCta.creatorLabel')}
                </a>
              </p>
              <nav className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs text-gray-400">
                <button onClick={() => navigate("/affiliate")} className="hover:text-white">
                  {t('footerCta.joinAsAffiliate')}
                </button>
                <button onClick={() => navigate("/contact-us")} className="hover:text-white">
                  {t('footerCta.contactUs')}
                </button>
                <a
                  href="https://discord.gg/aprWSYE5JP"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-white"
                >
                  {t('footerCta.discord')}
                </a>
                <button onClick={() => navigate("/refund-policy")} className="hover:text-white">
                  {t('footerCta.refundPolicy')}
                </button>
                <button onClick={() => navigate("/privacy-policy")} className="hover:text-white">
                  {t('footerCta.privacyPolicy')}
                </button>
                <button onClick={() => navigate("/terms-and-conditions")} className="hover:text-white">
                  {t('footerCta.termsAndConditions')}
                </button>
                {isAuthenticated && (
                  <button onClick={() => setShowChangelog(true)} className="hover:text-white">
                    {t('footer.changelog', { ns: 'common', defaultValue: 'Changelog' })}
                  </button>
                )}
              </nav>
            </div>
          </div>
        ) : (
          <div className="py-1.5 text-center text-gray-500 text-xs">
            <p>
              {t('footerCta.copyright')}{" "}
              <a
                href="https://www.youtube.com/@boophie"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-white transition-colors"
              >
                {t('footerCta.creatorLabel')}
              </a>
            </p>
          </div>
        )}
      </footer>

      {showChangelog && <ChangelogDialog onClose={() => setShowChangelog(false)} />}
    </>
  );
};

export default Footer;
